import type { ReactNode } from 'react';
import { GovIcon, GovTag } from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { PageCode } from '@gov-nx/module/page/definitions/codes';
import { Button } from '@gov-nx/ui/web/Button/Button';
import { DocumentDownloadItem } from '@gov-nx/ui/web/DocumentDownload/DocumentDownloadItem';

type Props = {
	children: ReactNode;
	isFile?: boolean;
	fileSize?: number;
	name?: string;
	onRemoveClick?: () => void;
};

export const FormListItem = ({
	onRemoveClick,
	isFile = false,
	fileSize = 0,
	name,
	children,
}: Props) => {
	const { t: tn } = useLocale(PageCode['datove-schranky']);
	const button = (
		<Button
			color="primary"
			type="base"
			size="s"
			onClick={onRemoveClick}
			className="w-[38px]! ml-auto!"
			aria-label={tn('nova-zprava.wcag.odebrat')}
			iconStart={
				<GovIcon
					name="x-lg"
					type="components"
				/>
			}
		/>
	);

	return (
		<li className="w-full [ sm:w-auto ]">
			{isFile ? (
				<span className="document-download-static">
					<DocumentDownloadItem
						name={name}
						size={fileSize}>
						{button}
					</DocumentDownloadItem>
				</span>
			) : (
				<GovTag
					color="neutral"
					size="s"
					type="subtle"
					className="pr-0! bg-(--background-block-primary)!">
					{children}
					{button}
				</GovTag>
			)}
		</li>
	);
};
